export const SET_SHARE_SYSTEM_PERMISSION_ERROR =
  "VIDYO_CONNECTOR::GLOBAL_MESSAGES::SET_SHARE_SYSTEM_PERMISSION_ERROR";
